import { computed, queryCollection, useAsyncData } from "#imports";
import { usePageStore } from "@voix/store/pageStore";
import { ref } from "vue";
export default function voixLocaleSetup() {
  const pageStore = usePageStore();
  const localeData = ref({});
  const currentLocale = computed(() => {
    if (typeof pageStore.currentPage?.language_code === "string") {
      return pageStore.currentPage.language_code;
    }
    return "en";
  });
  void useAsyncData("locales", async () => queryCollection("locales").all()).then((theData) => {
    localeData.value = theData.data.value || [];
  });
  function t(key) {
    const currentData = localeData.value.find((item) => item.stem === `locales/${currentLocale.value}`);
    return currentData.meta[key] || key;
  }
  function getCurrentLocale() {
    return currentLocale.value;
  }
  return {
    t,
    getCurrentLocale
  };
}
